<template>
  <a-spin :spinning="formOption.busy">

    <a-form :form="form"
            :label-col="{ span: 12 }"
            :wrapper-col="{ span: 12 }"
    >

      <div class="form_title">基本信息</div>
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="关联客户">
            <a-input v-decorator="['custName']" :disabled="true"/>
            <!--            <picker v-decorator="['custId']"-->
            <!--                    :text="custData"-->
            <!--                    ref="equipTypePicker"-->
            <!--                    title="关联客户"-->
            <!--                    @select="selectPicker"-->
            <!--            >-->
            <!--              <template v-slot:childTable>-->
            <!--                <custPicker ref="custPicker"-->
            <!--                            @getTableData="getTableData"></custPicker>-->
            <!--              </template>-->
            <!--            </picker>-->
          </a-form-item>
        </a-col>

          <a-col :span="8">
            <a-form-item label="线索来源">
              <!--            <a-select-->
              <!--                :allowClear="true"-->
              <!--                disabled="true"-->
              <!--                v-decorator="['clueSourceId']"-->
              <!--                :options="clueSourceOptions"-->
              <!--            >-->
              <!--            </a-select>-->
              <a-input v-decorator="['clueSourceName']" :disabled="true"/>
            </a-form-item>
          </a-col>


        <a-col :span="8">
          <a-form-item label="下次跟进时间">
            <a-input v-decorator="['nextCallonDate']"
                     :disabled="true"/>
            <!--            <a-date-picker-->
            <!--                :mode="mode"-->
            <!--                show-time-->
            <!--                @openChange="handleOpenChange"-->
            <!--                @panelChange="handlePanelChange"-->
            <!--                v-decorator="['nextCallonDate']"-->
            <!--                value-format="YYYY-MM-DD HH:mm:ss"/>-->
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="负责人">
            <a-input v-decorator="['clueUserName']"
                     :disabled="true"/>
            <!--            <picker v-decorator="['clueUserId']"-->
            <!--                    :text="deptData"-->
            <!--                    ref="equipTypePicker"-->
            <!--                    title="负责人"-->
            <!--                    @select="selectPicker"-->
            <!--            >-->
            <!--              <template v-slot:childTable>-->
            <!--                <deptPicker ref="deptPicker"-->
            <!--                            @getTableData="getTableData"></deptPicker>-->
            <!--              </template>-->
            <!--            </picker>-->
          </a-form-item>
        </a-col>

      </a-row>

      <div class="form_title">客户工况</div>
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="运输路线">
            <a-input v-decorator="['transportRoute']" :disabled="true"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="运输路况">
            <a-input v-decorator="['transportConditionName']" :disabled="true"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="运输距离">
            <a-input v-decorator="['transportDist']" :disabled="true"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="运输区域地势">
            <a-input v-decorator="['transportTerrainName']" :disabled="true"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="运输货物类型">
            <a-input v-decorator="['transportGoodsTypeName']" :disabled="true"/>
          </a-form-item>
        </a-col>
      </a-row>

      <div class="form_title">意向信息</div>
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="意向等级">
            <a-input v-decorator="['wantLevelName']"
                     :disabled="true"/>
            <!--            <a-select-->
            <!--                :allowClear="true"-->
            <!--                v-decorator="['wantLevel']"-->
            <!--                :options="wantLevelOptions"-->
            <!--            >-->
            <!--            </a-select>-->
          </a-form-item>
        </a-col>
        <!--        <a-col :span="8">-->
        <!--          <a-form-item label="联系电话">-->
        <!--            <a-input-->
        <!--                v-decorator="['custPhone']"></a-input>-->
        <!--          </a-form-item>-->
        <!--        </a-col>-->
        <a-col :span="8">
          <a-form-item label="意向品系">
            <!--            <a-select-->
            <!--                :allowClear="true"-->
            <!--                v-decorator="['strainId']"-->
            <!--                :options="strainOptions"-->
            <!--            >-->
            <!--            </a-select>-->
            <a-input v-decorator="['strainName']"
                     :disabled="true"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="意向品牌">
            <!--            <a-select-->
            <!--                :allowClear="true"-->
            <!--                v-decorator="['wantBrand']"-->
            <!--                :options="brandData"-->
            <!--             ></a-select>-->
            <a-input v-decorator="['wantBrandName']"
                     :disabled="true"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="预购数量">
            <a-input v-decorator="['wantCount']"
                     :disabled="true"/>
          </a-form-item>
        </a-col>
        <!--        <a-col :span="8">-->
        <!--          <a-form-item label="线索详情">-->
        <!--            <a-input v-decorator="['clueDesc']"-->
        <!--                     :disabled="true"/>-->
        <!--          </a-form-item>-->
        <!--        </a-col>-->
        <a-col :span="8">
          <a-form-item label="预计购车日期">
            <a-input v-decorator="['estimateBuyDate']"
                     :disabled="true"/>
            <!--            <a-date-picker-->
            <!--                :mode="mode"-->
            <!--                show-time-->
            <!--                @openChange="handleOpenChange"-->
            <!--                @panelChange="handlePanelChange"-->
            <!--                v-decorator="['nextCallonDate']"-->
            <!--                value-format="YYYY-MM-DD HH:mm:ss"/>-->
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="客户关注点">
            <!--            <a-select-->
            <!--                :allowClear="true"-->
            <!--                v-decorator="['wantBrand']"-->
            <!--                :options="brandData"-->
            <!--             ></a-select>-->
            <a-input v-decorator="['customerAttentionName']"
                     :disabled="true"/>
          </a-form-item>
        </a-col>
      </a-row>
      <div v-if="isFail">

        <div class="form_title">战败信息</div>
        <a-row :gutter="24">

<!--          <a-col :span="8">-->
<!--            <a-form-item label="战败原因">-->
<!--              <a-input v-decorator="['failReasonName']" :disabled="true"/>-->
<!--            </a-form-item>-->
<!--          </a-col>-->

          <a-col :span="8">
            <a-form-item label="流失车型代码">
              <a-input v-decorator="['lostModel']" :disabled="true"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="流失数量">
              <a-input v-decorator="['lostNum']" :disabled="true"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="改进建议">
              <a-input v-decorator="['suggessImprove']" :disabled="true"/>
            </a-form-item>
          </a-col>

        </a-row>
      </div>

    </a-form>
    <a-tabs>
      <!-- qf09 -->
      <a-tab-pane key="1" tab="线索跟进记录" :forceRender="true">
        <clueProp ref="clueProp" :rowId="rowId"></clueProp>
      </a-tab-pane>
      <a-tab-pane key="2" tab="合同文件" :forceRender="true">
        <div class="contract_img fix" v-if="originalPictureUrl || scanningCopyUrl">
          <a :href="scanningCopyUrl" target="_blank" v-if="scanningCopyUrl">
            <img :src="scanningCopyUrl" alt="" class="l">
          </a>
          <a :href="originalPictureUrl" target="_blank" v-if="originalPictureUrl">
            <img :src="originalPictureUrl" alt="" class="l">
          </a>
        </div>

      </a-tab-pane>
      <a-tab-pane key="3" tab="战败原因" :forceRender="true">
        <failReason ref="failReason"></failReason>
      </a-tab-pane>
    </a-tabs>
    <!--    <a-space class="a-form-btn-box">-->
    <!--      <a-button @click="close()">取消</a-button>-->
    <!--      <a-button type="primary" @click="_save(false)">提交</a-button>-->
    <!--    </a-space>-->
  </a-spin>
  <!-- 详情页 -->


</template>

<script>
import {formMixin, fmt, loadBaseCodeData} from '@/utils/common/FormBase'
//厂商用户管理接口
import {dataApi} from '@/services/clue/clueManage.js';
// import XEUtils from "xe-utils";
import clueProp from "@/pages/web/clue/clueManage/detail/clueProp";
// import custPicker from "@/pages/web/clue/clueManage/detail/custPicker";
// import deptPicker from "@/pages/web/clue/clueManage/detail/deptPicker";
import failReason from "./detail/failReason";
import api from "@/services/api";

/**
 * 加载规则 必填控制我
 */
function getRulesTemplate() {
  return {
    clueSourceId: {
      rules: [{required: true, message: "选择线索来源"}]
    },
    clueDesc: {
      rules: [{required: true, message: "请输入线索详情"}]
    },
    nextCallonDate: {
      rules: [{required: true, message: "请选择下次跟进日期"}]
    },
    custId: {
      rules: [{required: true, message: "请选择关联客户"}]
    },
    strainId: {
      rules: [{required: true, message: "请选择意向品系"}]
    },
    wantCount: {
      rules: [{required: true, message: "请输入预购数量"}]
    },
    wantLevel: {
      rules: [{required: true, message: "请选择意向等级"}]
    },
    wantBrand: {
      rules: [{required: true, message: "请选择意向品牌"}]
    },
    clueUserId: {
      rules: [{required: true, message: "请选择负责人"}]
    }
  };
}


/**
 * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
 * 一般是用来写表单默认值 或者写不在表单中需要保存的值
 * @returns {Object}
 */
function newEntity() {
  return {};
}


/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {
  let entity = await dataApi.getFormDetail(rowId);
  // entity.data = entity.data.entity
  // this.custData=entity.data.entity.custName

  if(entity.data.wantLevel === '200026'){
    this.isFail = true;
  }
  return fmt.formatFormLoad(entity);
}


/**
 * 加载数据之后执行的函数(新建表单也会执行)
 */
async function afterLoad(entity) {
  console.log(entity)
  this.setRefsValue({
    failReason: entity.failureList,
  })
  if (this.keyId) {
    let res = await dataApi.getReportList(this.keyId)
    console.log('数据',res);
    if(res.data.list&&res.data.list[0]?.originalPictureUrl){ //合同图片

    this.originalPictureUrl = api.temp.FILE_PATH+res.data.list[0]?.originalPictureUrl

    }else{
      this.originalPictureUrl = ''
    }

    if(res.data.list&&res.data.list[0]?.scanningCopyUrl){ //合同图片

      this.scanningCopyUrl = api.temp.FILE_PATH+res.data.list[0]?.scanningCopyUrl

    }else{
      this.scanningCopyUrl = ''
    }
    // // 修改v-decorator的值
    // this.form.setFieldsValue({
    //   clueSourceId: res.clueSourceName
    // })
    this.setRefsValue({
      clueProp: res.data.list,
    })
  }
}


/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function save(entities) {
  console.log(entities)
  //给主键赋值
  // // entities.clueId = vm.keyId;
  // let data;
  // data.entity = entities;

  let clueProp = await this.getChildDataNew('clueProp');
  entities.saleClubReportList = clueProp;
  // // entities.goodsId = vm.keyId;
  // entities.saleClubReportList = clueProp;
  // entities.delSkuList = clueProp.del.map(v => {
  //   return v.skuId
  // });
  return await dataApi.saveFormDetail(entities);
}

/**
 * 加载基础数据
 */
async function loadBaseData() {
  this.clueSourceOptions = await loadBaseCodeData('CD200004')
  this.clueUserOptions = await loadBaseCodeData('CD200004')
  // this.strainOptions=await loadBaseCodeData('CD200007')
  this.wantLevelOptions = await loadBaseCodeData('CD200002')

  let commCodeData = await dataApi.getCommCode();
  // let DeptUsers = await dataApi.getDeptUsers();
  // if(DeptUsers.code!==200){
  //
  // }
  this.strainOptions = commCodeData.data.strain.map(v => {
    return {
      label: v.code_name,
      value: v.code_id
    }
  })

  this.brandData = commCodeData.data.brand.map(v => {
    return {
      label: v.code_name,
      value: v.code_id
    }
  })
  // this.DeptUsersData=DeptUsers.data.list.map(v=>{
  //   return{
  //     label: v.deptId,
  //     value: v.deptId
  //   }
  // })
}


/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  components: {
    clueProp,
    failReason
    // custPicker,
    // deptPicker,
  },
  data() {
    return {
      mode: 'time',
      treeData: [],
      DeptUsersData: [],
      clueSourceOptions: [],
      clueUserOptions: [],
      strainOptions: [],
      wantLevelOptions: [],
      custData: '',
      deptData: '',
      brandData: [],
      isFail:false, // 是否是战败
      scanningCopyUrl:'',//合同照片
      originalPictureUrl:'',//合同图片
    }
  },
  computed:{
    // isFail:function (){
    //   return this
    // }
  },
  methods: {
    loadEntity,
    newEntity,
    save,
    getRulesTemplate,
    afterLoad,
    loadBaseData,
    handleOpenChange(open) {
      if (open) {
        this.mode = 'time';
      }
    },
    handlePanelChange(value, mode) {
      this.mode = mode;
    },

    /**
     * 弹出层选择器的回调方法
     * 插槽内子表的回调函数
     * @param res 选中项的值
     * @param type 组件名
     */
    getTableData(res, type) {
      console.log(res)
      switch (type) {
        case 'custPicker': {
          console.log(res)
          this.custData = res.custName;

          this.setFormValue({
            custId: res.custId
          })
        }
          break;
        case 'deptPicker': {
          console.log(res)
          this.deptData = res.userName;
          this.setFormValue({
            clueUserId: res.userId
          })
        }
          break;
        default:
          break
      }
    },
  }
};
</script>

<style scoped lang="stylus">
/deep/ .vxe-toolbar {
  height 10px
}
  .contract_img{
    width: 100%;

  }
  .contract_img img{
    width:100px;
    height:  120px;
    object-fit cover
    margin-right 32px
  }
    .contract_img img:first-child{
      margin-left: 78px;
    }
</style>
